module.exports = __webpack_public_path__ + "icon-user.png?6725f1cf58b4a0b20a2c9470fbdc53a2";